import { createAction, createSlice } from '@reduxjs/toolkit'

// to reset this slice to inital state use this with dispatch(WebConfigReset())
export const WebConfigReset = createAction('WebConfigReset')

export interface WebConfigStateProps {
  webConfig: any;
  isDarkMode: boolean;
  storedSearches: any[];
}

export const initialStateOfWebConfig: WebConfigStateProps = {
  webConfig: {},
  isDarkMode: false,
  storedSearches: []
};

export const webConfig = createSlice({
  name: 'webconfig',
  initialState: initialStateOfWebConfig,
  extraReducers: (builder) => builder.addCase(WebConfigReset, () => initialStateOfWebConfig), // to reset this slice
  reducers: {
    toggleDarkMode: (state) => {
      state.isDarkMode = !state.isDarkMode
    },
    setWebConfigKeys: (state, action) => {
      state.webConfig = action.payload.keys;
    },
    setStoredSearches: (state, action) => {
      try {
        let storedSearches = state.storedSearches || [];
        const newSearch = action.payload;

        storedSearches = JSON.parse(JSON.stringify(storedSearches))

        const existingIndex = storedSearches.findIndex((search: any) => {
          return (
            search?.origin?.stationCode?.toLowerCase() === newSearch?.origin?.stationCode?.toLowerCase() &&
            search?.destination?.stationCode?.toLowerCase() === newSearch?.destination?.stationCode?.toLowerCase()
          );
        });
      
        if (existingIndex !== -1) {
          // Duplicate stationCode found, remove the existing entry
          storedSearches.splice(existingIndex, 1);
        }
      
        const updatedSearches = [newSearch, ...storedSearches.slice(0, 4)];
        state.storedSearches = updatedSearches;
      } catch(error){
        console.error("Error in setStoredSearches:", error);
        return state
      }
    }
  }
});

export const { setWebConfigKeys, toggleDarkMode, setStoredSearches } = webConfig.actions;

export const selectWebConfigState = (state: any) => state.persistedReducers.webConfig

export const getIsDarkMode = (state: any) => Boolean(state.persistedReducers.webConfig?.isDarkMode)

export default webConfig.reducer;